import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { DEMO_URL } from '../constants';

const BG = '/images/hero-stadium.png';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, ease: 'easeOut', delay },
});

export default function FinalCTA({ onDemoClick }) {
  const { t } = useLanguage();
  const c = t.finalCta;

  return (
    <section className="relative py-20 md:py-28 overflow-hidden" data-testid="final-cta-section">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img src={BG} alt="Stadium" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1F2833]/96 via-[#0F6B49]/40 to-[#1F2833]/95" />
      </div>

      {/* Glow blobs */}
      <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-[#D5A63B]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-[#0F6B49]/20 rounded-full blur-3xl" />

      <div className="section-container relative z-10 text-center">
        <motion.div {...fadeUp()}>
          <h2 className="heading-xl mb-3">
            {c.title1}<br />
            <span className="text-gradient-gold">{c.title2}</span>
          </h2>
        </motion.div>

        <motion.p className="text-[#F3F1EB]/80 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed"
          {...fadeUp(0.1)}>
          {c.subtitle}
        </motion.p>

        <motion.div className="flex flex-wrap justify-center gap-4" {...fadeUp(0.2)}>
          <a href={DEMO_URL} target="_blank" rel="noopener noreferrer"
            className="btn-primary text-base px-10 py-4 text-lg no-underline" data-testid="final-cta-primary">
            {c.cta1}
          </a>
          <button onClick={onDemoClick} className="btn-secondary text-base px-10 py-4 text-lg" data-testid="final-cta-secondary">
            {c.cta2}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
